import { Controller } from "@hotwired/stimulus"

//
//== SWIPER
import { Swiper } from "swiper";
import { Navigation } from 'swiper/modules';

export default class extends Controller {

  connect () {

    const params = {
      loop: true,
      navigation: {
        enabled: true,
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
      modules: [Navigation],
      breakpoints: {
        768: { spaceBetween: 16 },
        1024: {
          slidesPerView: 2,
          spaceBetween: 32,
          navigation: { enabled: false },
        },
        1280: { slidesPerView: 2, spaceBetween: 48, navigation: { enabled: true } },
        1920: { spaceBetween: 64 },
      },
    };

    const swiper = new Swiper('.swiper', params);

  }

  disconnect () {
    Swiper.destroy();
  }
}
